import { render, staticRenderFns } from "./LocalPayments.vue?vue&type=template&id=5bf0f694&scoped=true"
import script from "./LocalPayments.vue?vue&type=script&lang=js"
export * from "./LocalPayments.vue?vue&type=script&lang=js"
import style0 from "./LocalPayments.vue?vue&type=style&index=0&id=5bf0f694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0f694",
  null
  
)

export default component.exports